import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Session from '../services/session'
import i from '../imports';
import c from '../components';

const EMPTY_FILTER_VALUE = "empty_filter_value";


const floatingLabelStyleInForm = {
    color: "#BDBDBD"
}

const floatingLabelStyle = {
    color: "#FF5563"
}

const underlineStyle = {
    borderColor: "#FF5563"
}

class AccomodationDialog extends Component {
    constructor(props) {
        super(props);
         this.state = {
              accomodationValue: this.props.hotel
        //     dateValue: this.props.calcValues.dateValue,
        //     languageValue: this.props.calcValues.languageValue,
        //     toursNumberValue: this.props.calcValues.toursNumberValue,
         }
    }

    render() {

        return (
            <c.FormDialog
                onClose={this.props.onClose}
                openDialog={this.props.openDialog}
                form_title={this.props.form_title}
                form_description={this.props.form_description}
                calcValues={this.state}
                requestType = 'accomodationRequest'
            >
                <i.Row>
                    <i.Col style={{ color: "#FF5563" }}>
                        {this.props.hotel}
                    </i.Col>
                </i.Row>
            </c.FormDialog>
        )

    }
}

export { AccomodationDialog };